var exports = {
  "_": "xfd349460--90e1da--nav_container" + " " + __webpack_require__(33767)["sectorWithSticky"],
  "Y": "xfd349460--90e1da--reviews",
};

module.exports = exports;
